import React from "react";

// An uploaded icon (a single-color PNG on a transparent background) drawn in the
// current text color: the PNG's transparency cuts the shape out of a box filled
// with currentColor, so text-primary / text-secondary color it like SvgIcon did.
// For the app's own SVGs (public/), keep using SvgIcon.
function MaskIcon({ src, className = "", label, ...rest }) {
  if (!src) return null;
  const mask = `url("${src}") center / contain no-repeat`;
  return (
    <span
      role="img"
      aria-label={label}
      className={`inline-block bg-current ${className}`}
      style={{ mask, WebkitMask: mask }}
      {...rest}
    />
  );
}

export default MaskIcon;
